export const NavbarActionTypes = {
    MOVE_NAVBAR_ELEMENTS : "MOVE_NAVBAR_ELEMENTS",
    MOVE_USER_NAVBAR_ELEMENTS : "MOVE_USER_NAVBAR_ELEMENTS"
}